/** @flow */
import styled from 'styled-components';

const Layout = styled.div`
  margin: 0px;
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  min-height: 100vh;
  height: 100%;
  
  .app-content.expandedV2 {
    padding-left: ${props => props.theme.V3.metrics.menu.width}px;
  }
`;

const Logo = styled.img`
  height: 54px;
  marginTop: 5px;
`;

export {
  Layout,
  Logo,
};



// WEBPACK FOOTER //
// ./src/statsradio/layout/styles/index.js